module.exports = __webpack_public_path__ + "fonts/SFUIDisplay-Medium.a03732f2.ttf";